(function () {
  var PRINTFRIENDLY_ELEMENTS = [
    "body",
    "#topBar",
    ".batchgeo-toolbar",
    ".gmnoprint",
    ".gm-svcp",
    "#legWrap",
    "#legDiv",
    ".clusterize-content",
    "clusterize-faux-thead",
    ".clusterize-scroll",
    ".clusterize-bottom-space",
    "#descriptionWrap",
    "#description",
  ];

  var PRINTFRIENDLY_CLASS = "printfriendly";
  var PRINTFRIENDLY_MAP_ID = "printfriendly_map";

  var $pleaseWait;

  function printingIsAllowed() {
    var state = BatchGeoStore.getState().App;
    return !state.isMobile;
  }

  /**
   * BatchGeoPrinter - A revealing module that is the main entry point for the
   * advanced printer. This module coordinates handling hotkey pressing, shimming
   * printe events across browsers and allowing the user to initiate an advanced print
   * if they are pro users, or a basic print if they are not.
   *
   * @returns {Object}  This exposes the printViewOn, printViewOff and dialog
   * methods to other modules.
   */
  function BatchGeoPrinter() {
    var printerDialog = new window.PrinterDialog();
    var map = window.batchGeoGoogleMapsManager.getMap();
    var currentMapTypeId = map.getMapTypeId();

    if (!map.mapTypes[PRINTFRIENDLY_MAP_ID]) {
      var printStyledMap = new google.maps.StyledMapType(
        window.styles.printFriendly,
        { name: "Printfriendly Styled" },
      );
      map.mapTypes.set(PRINTFRIENDLY_MAP_ID, printStyledMap);
    }

    function pleaseWaitMessage() {
      return (
        '<div class="printer-please-wait">' +
        '<label class="printer-please-wait-label">Please Wait... </label>' +
        "</div>"
      );
    }

    /**
		 * printViewOff - this fires when printing is over and basically is
		 * responsible for disposing all elements and special things used during
		 * the advanced print such as the dialog, and any special CSS needed to achieve
		 * the print layout and styling on the map.
		 * If advanced printing is not allowed (such as not having a Pro account),
		 * the function essentially does nothing.
		 *
		 * Because the act of teardown can be costly
		 * (removing many DOM elements in the print-table and applying the Google
		 * Map styles) The function first appends a 'please wait' message.
		 *

		 * @returns {none}  This event returns nothing.
		 */
    function printViewOff() {
      if (!printingIsAllowed()) {
        return;
      }

      if (!$pleaseWait) {
        $pleaseWait = $(pleaseWaitMessage());
        $(document.body).append($pleaseWait);
      }

      // If you've noticed the unusual series of setTimeouts, that is because
      // this event fires as a side effect in the browser,and if you do not
      // temporarily stagger some of these events, there can be artifacts, such
      // as the browser not resizing correctly at the end or the 'please wait'
      // not getting appended clearly before teardown.
      setTimeout(function () {
        BatchGeoStore.dispatch({ type: "PRINTER_DEACTIVATE" });
        window.batchGeoTableMap.batchGeoPrintTable.deactivate();
        map.set("styles", window.styles[window.per.style]);
        map.setMapTypeId(currentMapTypeId);

        $(PRINTFRIENDLY_ELEMENTS.join()).removeClass(PRINTFRIENDLY_CLASS);
        setTimeout(function () {
          $("body,#topBar").removeClass("force-landscape");

          window.batchGeoMap.bgSize();

          $(window).trigger("resize");

          if ($pleaseWait) {
            $pleaseWait.remove();
            $pleaseWait = null;
          }

          // Resizing and closing print will trigger all kinds of map
          // events so we need to wait until those have all completed
          // and then we can call fitBounds and setZoom to put the map
          // back where it was before we started printing.
          google.maps.event.addListenerOnce(map, "idle", function () {
            var printerState = BatchGeoStore.getState().Printer;
            window.batchGeoGoogleMapsManager.map.fitBounds(printerState.bounds);
            window.batchGeoGoogleMapsManager.map.setZoom(printerState.zoom);
          });
        }, 250);
      }, 100);
    }

    function userUsedPrintHotkey(keyEvent) {
      return (
        (keyEvent.metaKey || keyEvent.ctrlKey) &&
        (keyEvent.key == "p" ||
          keyEvent.charCode == 16 ||
          keyEvent.charCode == 112 ||
          keyEvent.keyCode == 80)
      );
    }

    function beforePrint() {
      return false;
    }

    function afterPrint() {
      printViewOff();
    }

    function printShim(mql) {
      if (mql.matches) {
        beforePrint(mql);
      } else {
        afterPrint(mql);
      }
    }

    //grabs printing hotkey
    function printHotkey(eve) {
      if (userUsedPrintHotkey(eve)) {
        eve.cancelBubble = true;
        eve.preventDefault();
        eve.stopPropagation();
        eve.stopImmediatePropagation();
        if (printingIsAllowed()) {
          printerDialog.open();
        } else {
          window.print();
        }
        return false;
      }
    }

    function initializePrinter() {
      /**
       * This attaches a listener to the window
       * if the window has window.matchMedia and also to the
       * windows print events.
       * and is the way to attach a cross browser printing-shim
       * whenever a print occurs.
       * Mainly used for 'teardown' after print.
       */
      if (window.matchMedia) {
        window.matchMedia("print").addListener(printShim);
      }
      window.onbeforeprint = beforePrint;
      window.onafterprint = afterPrint;

      /**
       * This function attaches to the print hotkey
       */
      $(document).on("keyup keydown", printHotkey);
    }

    /**
     * printViewOn -
     *
     * @param  {Object} printChoice This is the individual object that represents the chosen print seleciton.
     * @returns {none}              This function has no return type.
     */
    function printViewOn(printChoice) {
      if (!printingIsAllowed()) {
        return;
      }

      var options = printChoice.options;

      if (
        options.printfriendlyMap &&
        map &&
        map.getMapTypeId() != "satellite"
      ) {
        map.set("styles", window.styles.printfriendly);
        map.setMapTypeId(PRINTFRIENDLY_MAP_ID);
      }

      $(PRINTFRIENDLY_ELEMENTS.join()).addClass(PRINTFRIENDLY_CLASS);
      BatchGeoStore.dispatch({ type: "PRINTER_ACTIVATE" });

      window.batchGeoTableMap.batchGeoPrintTable.activate(options);
    }

    /**
     * Initializing the Printer
     *
     * This will attach
     * listeners to the global print events
     * and also listen for a cross-platform
     * printing 'hotkey'
     */
    initializePrinter();

    return {
      printViewOn: printViewOn,
      printViewOff: printViewOff,
      dialog: printerDialog.open,
    };
  }

  window.BatchGeoPrinter = BatchGeoPrinter;
})();
